module.exports = __webpack_public_path__ + "static/media/inigo-errejon.8891a7b1.png";